import i18n from "./i18n";

const MAIL_REGEX = /.+@.+\.[^.]{2,}/;
const URL_REGEX = /^https?:\/\/,*/;
const ZIPCODE_REGEX = /^\d{5}$/;
const YEAR_REGEX = /^\d{4}$/;

export function required(value, errorMsg) {
  return (
    (value || "").trim() != "" || errorMsg || i18n.t("validators.required")
  );
}

export function requiredArray(value, errorMsg) {
  return value.length > 0 || errorMsg || i18n.t("validators.requiredArray");
}

export function selectionRequired(value, errorMsg) {
  value = Array.isArray(value) ? value[0] : value;
  return (
    (value || "").trim() != "" || errorMsg || i18n.t("validators.required")
  );
}

export function email(value) {
  return !value || MAIL_REGEX.test(value) || i18n.t("validators.email");
}

export function url(value) {
  return !value || URL_REGEX.test(value) || i18n.t("validators.url");
}

export function zipcode(value) {
  return !value || ZIPCODE_REGEX.test(value) || i18n.t("validators.zipcode");
}

export function year(value) {
  return !value || YEAR_REGEX.test(value) || i18n.t("validators.year");
}

export function requiredSkillset(value) {
  if (!value || value.length === 0) {
    return i18n.t("validators.required");
  }
  if (value.some((item) => !item.proficiency)) {
    return i18n.t("validators.skillset");
  }

  return true;
}
